import React, { Component } from 'react';
import _ from 'underscore';
import { FormControl } from 'react-bootstrap';
import { mixinsClassName, contiansKeyword, dom } from '../../utils';
import Menu from '../menu';
import Item from './item';

export default class extends Component {
    constructor(props) {
        super(props);

        this.state = {
            data: _.map(this.props.data, (item, index) => {
                return _.extend({ _index: index }, item);
            }),
            selectedData: []
        };
    }

    getSelectedData() {
        return this.state.selectedData;
    }

    getSelectedIds() {
        const { idKey = 'id' } = this.props;
        return _.map(this.getSelectedData(), (item) => {
            return item[idKey];
        })
    }

    onCloseItem(item) {
        let { data, selectedData } = this.state;
        let index = _.findIndex(selectedData, { _index: item._index });

        selectedData.splice(index, 1);
        delete data[item._index]._deleted;
        this.setState({
            data: data
        });
    }

    onSelectItem(item) {
        let { data, selectedData } = this.state;
        let inputEl = dom(this.refs.input);

        selectedData.push(item);
        data[item._index]._deleted = true;
        inputEl.val('');
        inputEl[0].focus();

        this.setState({
            data: data
        });
    }

    onInputClick() {
        // let inputEl = dom(this.refs.input);
        // let value = inputEl.val().trim();
        this.refs.menu.show();
    }

    onInputChange() {
        this.setState({
            keyword: dom(this.refs.input).val().trim()
        })
        this.refs.menu.show();
    }

    onClick() {
        dom(this.refs.input)[0].focus();
        this.refs.menu.show();
    }

    render() {
        const { style, textKey = 'text', matchKeys = [], placeholder } = this.props;
        let { keyword, data, selectedData } = this.state;
        let className = mixinsClassName("ui-tag clearfix", this.props);
        let sugData = [];

        _.each(data, item => {
            if (!item._deleted) {
                if (!keyword || contiansKeyword(keyword, item, textKey, ...matchKeys)) {
                    sugData.push(item);
                }
            }
        });

        return (
            <div className={className} style={style} onClick={this.onClick.bind(this)}>
              {
                selectedData.map((item)=>{
                  return <Item text={item[textKey]} onClick={(ev)=>{ev.stopPropagation()}} onClose={this.onCloseItem.bind(this, item)} style={{maxWidth: '100px'}}/>
                })
              }
              <FormControl ref="input" placeholder={placeholder} onClick={this.onInputClick.bind(this)} onChange={this.onInputChange.bind(this)} />
              <Menu ref="menu" textKey={textKey} data={sugData} onSelect={this.onSelectItem.bind(this)} />
            </div>
        )
    }
}


// WEBPACK FOOTER //
// ./src/ui/tag/index.js